<template>
    <div v-if="!loading">
        <highcharts
            :constructor-type="'chart'"
            :options="chartOptions"
            :updateArgs="[true, true, true, { duration: 2000 }]"
            class="chart"
            ref="highcharts"
        ></highcharts>
    </div>
    <div class="text-center pt-3 pb-3" v-else>
        <img src="loader.svg" style="width: 100px; height: 100px" />
    </div>
</template>

<script>
import Utils from '@/utils'
import { colorsCharts } from './colorsCharts.js'
import ChartsConfig from '@/mixins/Charts.Config.js'
import _ from 'lodash'

function getLabel(prefix, value) {
    const formattedValue = Utils.formatNumber(value, 'float', true)
    const label = prefix ? `${prefix} ${formattedValue}` : formattedValue

    return label
}

export default {
    props: {
        data: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        onClick: {
            type: Function
        },
        title: {
            type: String,
            default: ''
        },
        prefix: {
            type: String
        },
        keys: {
            type: Object,
            required: true
        },
        tracks: {
            type: Array
        }
    },
    mounted() {
        this.tracks.map(item => {
            this.filteredCategories.push(item.track)
        })
    },
    mixins: [ChartsConfig],
    data() {
        return {
            filteredCategories: [],
            chart_offsetWidth: null,
            chart_offsetHeight: null,
            class_info: null,
            column_keys: {
                normal: 'Estoque'
            },
            chartOptions: {
                chart: {
                    className: 'stock stock_chart_resize'
                },
                credits: {
                    text: '',
                    enabled: false
                },
                title: {
                    text: this.title
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    opposite: false,
                    startOnTick: true,
                    endOnTick: true,
                    showLastLabel: true,
                    tickPixelInterval: 40,
                    minPadding: 0,
                    maxPadding: 0,
                    minRange: 1,
                    min: 0,
                    maxRange: 20
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderRadius: 3
                    },
                    series: {
                        cursor: 'pointer',
                        events: {
                            click: event => {
                                let eventClick = {
                                    name: event.point.name,
                                    category: event.point.category
                                }
                                this.onClick(eventClick)
                            },
                            legendItemClick: function() {
                                //Ocultar grafico quando clicar na legenda
                                if (!this.visible) {
                                    this.chart.series[this.index].show()
                                } else {
                                    let check = false

                                    if (this.index <= 4)
                                        check = this.chart.series.some(
                                            (serie, index) =>
                                                !serie.visible &&
                                                this.index <= 4 &&
                                                index <= 4
                                        )
                                    else
                                        check = this.chart.series.some(
                                            (serie, index) =>
                                                !serie.visible &&
                                                this.index > 4 &&
                                                index > 4
                                        )

                                    if (!check) {
                                        this.chart.series.map(
                                            (serie, index) => {
                                                if (index === this.index)
                                                    serie.show()
                                                else if (
                                                    this.index <= 4 &&
                                                    index <= 4
                                                )
                                                    serie.hide()
                                                else if (
                                                    this.index > 4 &&
                                                    index > 4
                                                )
                                                    serie.hide()
                                            }
                                        )
                                    } else {
                                        this.chart.series.map(
                                            (serie, index) => {
                                                if (
                                                    this.index <= 4 &&
                                                    index <= 4
                                                )
                                                    serie.show()
                                                else if (
                                                    this.index > 4 &&
                                                    index > 4
                                                )
                                                    serie.show()
                                            }
                                        )
                                    }
                                }

                                return false
                            }
                        }
                    }
                }
            }
        }
    },
    methods: {
        datasource() {
            if (!this.data) return

            const dataChart = this.data.map((value, index) => {
                if (value) {
                    return {
                        name: value.curve,
                        data: _.map(value[this.keys.objectKey], item => {
                            return {
                                name: value.curve,
                                y: Number(
                                    Number(item[this.keys.valueKey]).toFixed(2)
                                )
                            }
                        }),
                        color: colorsCharts.colorDefault[index],
                        tooltip: {
                            valuePrefix: this.prefix
                        },
                        styledMode: true,
                        type: 'column'
                    }
                }
            })

            if (this.$refs.highcharts?.chart) {
                this.$refs.highcharts.chart.update({
                    series: dataChart
                })
            } else {
                this.chartOptions.xAxis = {
                    categories: this.filteredCategories
                }
                this.chartOptions.series = dataChart
            }

            this.setLabels()
        },
        setLabels() {
            const prefix = this.prefix

            this.chartOptions.yAxis.labels = {
                formatter: function() {
                    return getLabel(prefix, this.value)
                }
            }

            this.chartOptions.yAxis.stackLabels = {
                style: { color: 'black' },
                enabled: true,
                formatter: function() {
                    return getLabel(prefix, this.total)
                }
            }

            this.chartOptions.plotOptions.column.dataLabels = {
                enabled: false,
                formatter: function() {
                    return getLabel(prefix, this.y)
                }
            }
        }
    },
    watch: {
        data: {
            handler: function(data) {
                this.datasource()
            }
        },
        tracks: {
            handler: function(tracks) {
                const mapCategories = tracks.map(item => {
                    if (!item.isChecked) {
                        return { track: item.track }
                    }
                })
                const filterCategories = this.filteredCategories.filter(
                    (e, index) => {
                        return e.track === mapCategories[index]?.track
                    }
                )
                this.$refs.highcharts.chart.update({
                    xAxis: {
                        categories: filterCategories
                    }
                })
            }
        }
    }
}
</script>
<style scoped>
.stock .highcharts-color-0 .highcharts-point {
    fill: red !important;
    stroke: rgb(194, 28, 28) !important;
}
</style>
